var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5112 49.8508L92.483 56.5236L100.438 49.8508L108.393 56.5236L116.348 49.8508L124.319 56.5236L132.291 49.8508",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.869 69.0543L124.149 36.5731C120.911 31.0783 115.005 27.7048 108.622 27.7048C102.239 27.7048 96.3326 31.0783 93.0948 36.5731L49.5303 105.033H192.615L165.266 66.2187C163.285 63.4198 160.077 61.7432 156.645 61.7129C153.213 61.6826 149.976 63.3024 147.946 66.0659L132.648 86.7805",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.608 73.9612L149.628 78.6135L156.631 73.9612L163.668 78.6135L170.688 73.9612",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.305 105.016L107.339 95.6097L115.226 84.8958C117.129 82.31 120.16 80.7957 123.373 80.826C126.585 80.8563 129.587 82.4275 131.441 85.0486L145.566 105.05",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.461 38.8653V60.8363",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179 49.8508H156.461V38.8653H179L175.771 44.3665L179 49.8508V49.8508Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4512 124.661C76.4371 124.661 76.4371 120.195 83.4061 120.195C90.3751 120.195 90.3921 124.661 97.378 124.661C104.364 124.661 104.347 120.195 111.333 120.195C118.319 120.195 118.319 124.661 125.288 124.661",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2764 139.518C104.262 139.518 104.262 135.069 111.231 135.069C118.2 135.069 118.217 139.518 125.203 139.518C132.189 139.518 132.172 135.069 139.158 135.069C146.144 135.069 146.144 139.518 153.113 139.518",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 124.557C7.93149 124.557 7.93149 118.406 14.8461 118.406C21.7607 118.406 21.7776 124.557 28.7091 124.557",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M204.2 124.557C211.132 124.557 211.132 118.406 218.046 118.406C224.961 118.406 224.978 124.557 231.909 124.557",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4727 138.396C26.4041 138.396 26.4041 133.783 33.3188 133.783C40.2334 133.783 40.2503 138.396 47.1817 138.396",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.291 138.396C234.223 138.396 234.223 133.783 241.137 133.783C248.052 133.783 248.069 138.396 255 138.396",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.278 17.434C37.1484 11.4901 24.7224 7.52743 24.7224 13.9667C24.7224 7.52743 12.2964 11.4901 11.1667 17.434",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4726 36.0529C69.3429 30.109 56.9169 26.1463 56.9169 32.5856C56.9169 26.1463 44.491 30.109 43.3613 36.0529",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/mountain.3b030bd9326e9f7e860f35492b346303.svg";
export { ForwardRef as ReactComponent };